import { render, staticRenderFns } from "./DispensationFormsEscalated.vue?vue&type=template&id=607bb892&scoped=true&"
import script from "./DispensationFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./DispensationFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./DispensationFormsEscalated.vue?vue&type=style&index=0&id=607bb892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607bb892",
  null
  
)

export default component.exports